import { render, staticRenderFns } from "./catalogPanel.vue?vue&type=template&id=749f4922&scoped=true"
import script from "./catalogPanel.vue?vue&type=script&lang=js"
export * from "./catalogPanel.vue?vue&type=script&lang=js"
import style0 from "./catalogPanel.vue?vue&type=style&index=0&id=749f4922&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749f4922",
  null
  
)

export default component.exports